import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import { Box, IconButton, Typography } from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import { NewsCard } from 'components/news'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import State from 'states/types'
import { NivosNews } from 'types/nivos-news'
import {
  get,
  mapOperationsToDispatchProps,
  objectifyDateStringFields
} from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
  }
}

interface OwnProps {
  announcement: NivosNews
}

type AppProps = StateProps & DispatchProps & OwnProps

const AnnouncementFC: React.FC<any> = (props: AppProps) => {
  console.log(props.layout.language.name)
  const [activeNews, setActiveNews] = React.useState<NivosNews[]>([])
  const [announcementScrollPosition, setASPos] = React.useState(0)
  const announcementContainerRef = React.createRef<HTMLDivElement>()

  React.useEffect(() => {
    void get('/notification/active_news/')
      .then((data: NivosNews[]) => {
        setActiveNews(data.map(item => objectifyDateStringFields(item)))
      })
      .catch(e => console.log(e))
  }, [])

  return (
    <Box display={'flex'} flexDirection={'column'} padding={4}>
      <Box display={'flex'} alignItems={'flex-end'} paddingRight={4}>
        <Typography flexGrow={1} variant={'h4'} padding={2} paddingY={6}>
          ANNOUNCEMENTS
        </Typography>
        <IconButton
          sx={{ height: 'fit-content' }}
          onClick={() => {
            const current = announcementContainerRef.current
            if (current instanceof HTMLDivElement) {
              let newPosition = announcementScrollPosition - 595
              if (newPosition < 0) newPosition = 0
              setASPos(newPosition)
              current.scroll({
                left: newPosition,
                behavior: 'smooth'
              })
            }
          }}
        >
          <ChevronLeft />
        </IconButton>
        <IconButton
          sx={{ height: 'fit-content' }}
          onClick={() => {
            const current = announcementContainerRef.current
            if (current instanceof HTMLDivElement) {
              const maxWidth =
                current.scrollWidth - current.getBoundingClientRect().width
              let newPosition = announcementScrollPosition + 595
              if (newPosition > maxWidth) newPosition = maxWidth
              setASPos(newPosition)
              current.scroll({
                left: newPosition,
                behavior: 'smooth'
              })
            }
          }}
        >
          <ChevronRight />
        </IconButton>
      </Box>
      {activeNews.length === 0 && (
        <Typography variant={'h5'} paddingLeft={4}>
          <em>No Announcements</em>
        </Typography>
      )}
      {activeNews.length > 0 && (
        <Box
          overflow={'hidden'}
          width={1}
          height={205}
          position={'relative'}
          paddingTop={2}
        >
          <Box
            ref={announcementContainerRef}
            display={'flex'}
            position={'absolute'}
            width={1}
            overflow={'auto'}
            bottom={'-16px'}
          >
            {activeNews.map((item, index) => (
              <NewsCard key={index} news={item} />
            ))}
          </Box>
        </Box>
      )}
    </Box>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations
})

const Announcements = connect(
  mapStateToProps,
  mapDispatchToProps
)(AnnouncementFC)

export default Announcements
